// extracted by mini-css-extract-plugin
export default {"user-and-permissions__exclamation-warning-icon":"users-and-permissions_user-and-permissions__exclamation-warning-icon__YK3wn"};